module.exports = __webpack_public_path__ + "img/MailingAgradecimiento-4.e31bba02.png";